import React, { useState } from 'react';
import './App.scss';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Header from './components/header';
import Footer from './components/footer';
import Questions from './routes/questions';
import Registration from './routes/registration';
import Project from './routes/project';
import ProjectsPage from './routes/projects';
import Recommendations from './routes/recommendations';
import ThankYou from './routes/thankYou';
import Onboarding from './routes/onboarding';
import Guide from './routes/guide';
import Report from './routes/report';
import Terms from './routes/terms';
import Login from './routes/login';
import RequireAuth from './components/requireAuth';
import RequireLead from './components/requireLead';
import RequireAdmin from './components/requireAdmin';
import Logout from "./routes/logout";
import ErrorBoundary from './components/errorBoundary';
import NotFound from './components/notFound';
import ForgotPassword from './routes/forgotPassword';
import ResetPassword from './routes/resetPassword';
import TeamManagement from './routes/teamManagement';
import CreateUser from './routes/createUser';
import EditUser from './routes/editUser';
import Admin from './routes/admin';
import EditCompany from './routes/editcompany';
import ProjectsAdminPage from './routes/projectAdmin';
import CreateCompany from './routes/createcompany';
import AcceptableUsePolicy from './routes/acceptableUsePolicy';
import DataProtectionAddendum from './routes/dataProtectionAddendum';
import InformationSecurityAddendum from './routes/informationSecurityAddendum';
import PrivacyPolicy from './routes/PrivacyPolicy';

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RequireAuth><ProjectsPage /></RequireAuth>,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
    }, 
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/logout",
      element: <Logout />,
    },
    {
      path: "/registration",
      element: <RequireAuth><RequireAdmin><Registration /></RequireAdmin></RequireAuth>,
    },
    {
      path: "/admin",
      element: <RequireAuth><RequireAdmin><Admin /></RequireAdmin></RequireAuth>,
    },
     {
      path: "/project-admin",
      element: <RequireAuth><RequireAdmin><ProjectsAdminPage /></RequireAdmin></RequireAuth>,
    },
    {
      path: "/company/:id",
      element: <RequireAuth><RequireAdmin><EditCompany /></RequireAdmin></RequireAuth>,
    },
    {
      path: "/company/create",
      element: <RequireAuth><RequireAdmin><CreateCompany /></RequireAdmin></RequireAuth>,
    },
    {
      path: "/questions",
      element: <RequireAuth><Questions /></RequireAuth>,
    },
    {
      path: "/project",
      element: <RequireAuth><Project /></RequireAuth>,
      errorElement: <NotFound />
    },
    {
      path: "/projects",
      element: <RequireAuth><ProjectsPage /></RequireAuth>,
      errorElement: <NotFound />
    },
    {
      path: "/recommendations",
      element: <RequireAuth><Recommendations /></RequireAuth>,
      errorElement: <NotFound />
    },
    {
      path: "/team-management",
      element: <RequireAuth><RequireLead><TeamManagement/></RequireLead></RequireAuth>
    },
    {
      path: "/team-management/create",
      element: <RequireAuth><RequireLead><CreateUser/></RequireLead></RequireAuth>
    },
    {
      path: "/team-management/edit/:id",
      element: <RequireAuth><RequireLead><EditUser/></RequireLead></RequireAuth>
    },
    {
      path: "/thank-you",
      element: <RequireAuth><ThankYou /></RequireAuth>,
    },
    {
      path: "/onboarding/",
      element: <RequireAuth><Onboarding /></RequireAuth>,
    },
    {
      path: "/guide/",
      element: <RequireAuth><Guide /></RequireAuth>,
    },
    {
      path: "/report",
      element: <RequireAuth><Report /></RequireAuth>,
      errorElement: <NotFound />
    },
    {
      path: "/terms",
      element: <Terms />,
    },
    {
      path: "/acceptable-use-policy",
      element: <AcceptableUsePolicy />,
    },
    {
      path: "/data-protection-addendum",
      element: <DataProtectionAddendum />,
    },
    {
      path: "/information-security-addendum",
      element: <InformationSecurityAddendum />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <div className="App">
      <Header />
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
      <Footer />
    </div>
  );
}

export default App;

export const APIPATH = 'https://api.ourjourney.uk';
//export const APIPATH = 'http://localhost:5148';